import { ReplaySubject } from 'rx';
import { configs } from '../configs';
import { EventStreams } from '../data/EventStreams';
import { Nobles } from '../lib/anuket';
import { dateUtils } from '../lib/bastetjs/utils/dateUtils';
import { streamHook, eventBus } from '../data/Streams';

const FB_IMG_PATH = 'img/event/banner/facebook-icon/';

/**
 * Event helper class
 *
 * @property {number} athlinksId
 * @property {string} name
 * @property {boolean} hasHeroImage
 * @property {string} imageName
 * @property {number} startEpoch
 * @property {string} startTime
 * @property {number} latitude
 * @property {number} longitude
 * @property {string} timeZone
 * @property {string} city
 * @property {string} countryId
 */
export class Event {
  constructor(eventData = {}) {
    Object.assign(this, eventData);
    if (this.isLoaded()) {
      this.loadWeather();
    }
  }

  static get = (eventId) => {
    const eventSubject  = new ReplaySubject(1);
    EventStreams.getEventByEventId(eventId, 'kiosk-event')
      .subscribe(({ event }) => eventSubject.onNext(new Event(event)));
    return eventSubject;
  };

  static weather = (eventId) => streamHook(`weather-event-${eventId}`);

  get logoUrl() {
    if (!this.hasHeroImage) return null;
    return `${configs.customHeroImageUrl}${FB_IMG_PATH}${this.imageName}`;
  }

  get startEpochMs() {
    return this.startEpoch * 1000;
  }

  isLoaded = () => !!this.athlinksId;

  loadWeather = (lang) => {

    const location = this.location || {};
    const lat = this.latitude || location.latitude || false;
    const long = this.longitude || location.longitude || false;
    const timeZone = this.timeZone || location.timeZone || false;
    const eventTime = this.startEpoch || (Date.parse(this.startTime) / 1000) || false;

    if (lat && long) {
      Nobles.WeatherNoble.get({
        coords: [lat, long],
        dateTime: dateUtils.formatted(
          eventTime,
          '%FT%T%z',
          timeZone
        ),
        lang
      }).subscribe(({ weather }) => {
        eventBus.publish(`weather-event-${this.athlinksId}`, weather);
        this.weather = weather;
      });
    }
    return this;
  };

  getMaxTemperature = () => {
    if (!this.weather) return null;
    const { temperatureMax: tF, temperatureMaxCelsius: tC } = this.weather;
    if(tF && tC && !Number.isNaN(tF + tC)) return {fahrenheit: tF, celsius: tC};
    else return null;
  };

  extractRegionId = () => (this.regionId || '').split('-')[1] || '';
}



/** WEBPACK FOOTER **
 ** ./classes/Event.js
 **/